import { useEffect, useState } from "react";
import {
  Database,
  BookCheck,
  BoxesIcon,
  SettingsIcon,
  Edit3Icon,
  MessageSquareMore,
  LayoutDashboard as DashboardIcon,
  FileSignature as ContractIcon,
  Sprout as SeedsIcon,
  SprayCan as PesticidesIcon,
  Truck as DeliveryIcon,
  CandyCane as SugarIcon,
  Wheat as PulpIcon,
  ShieldCheck as GuaranteeIcon,
  Laptop2Icon,
  BadgeDollarSign,
  LeafyGreen,
  PhoneCall,
  CheckCircle,
  Sprout,
  User,
  HardDriveIcon,
} from "lucide-react";

import { getRoleId } from "Common/Components/getRoleId";

const MenuData = () => {
  const [userRole, setUserRole] = useState<any>(null);

  useEffect(() => {
    const role = getRoleId(localStorage.getItem("app_atkey") || "");
    setUserRole(role);
  }, []);

  const menuData: any = [
    // برای ادمین ادی 1
    ...(userRole === 1
      ? [
        {
          id: "DashBoard",
          label: "داشبورد",
          link: "/DashBoard",
          icon: <DashboardIcon className="w-4 h-4" />,
        },

        {
          id: "initialData",
          label: "داده های اولیه",
          link: "/#",
          icon: <Database />,
          subItems: [
            {
              id: "Year-registration",
              label: "ثبت سال زراعی ",
              link: "/Year-registration",
            },
            {
              id: "provincial-registration",
              label: "ثبت استان",
              link: "/ProvincialRegistration",
            },
            {
              id: "city-registration",
              label: "ثبت شهرستان",
              link: "/CityRegiste",
            },
            {
              id: "village-registration",
              label: "ثبت  روستا",
              link: "/villageRegister",
            },
            {
              id: "registerCar-registration",
              label: "ثبت انواع خودرو",
              link: "/registerCar",
            },
            {
              id: "registerdriver",
              label: "ثبت  راننده",
              link: "/registerdriver",
            },
            {
              id: "FACtoryy-registration",
              label: "ثبت کارخانه",
              link: "/factoryRegiste",
            },
            {
              id: "MeasurementPage-registration",
              label: "ثبت واحد اندازه گیری",
              link: "/MeasurementPage",
            },
            {
              id: "PoisonPage",
              label: "ثبت انواع سم",
              link: "/PoisonPage",
            },
            {
              id: "Seed-registration",
              label: "ثبت انواع بذر",
              link: "/SeedPage",
            },
            {
              id: "ProductPage",
              label: "ثبت انواع کالا",
              link: "/ProductPage",
            },

            {
              id: "PaymentTitle",
              label: "ثبت انواع پرداخت",
              link: "/PaymentTitlePage",
            },
            {
              id: "ProductPriceInCropYear",
              label: "ثبت قیمت کالا",
              link: "/ProductPriceInCropYearPage",
            },
            {
              id: "CutiePage",
              label: "ثبت قیمت عیار",
              link: "/CutiePage",
            },
            // ... سایر آیتم‌ها
            ...(userRole === 1 ? [{
              id: "CommissionPercentagePage",
              label: "کارمزد پیمانکار",
              link: "/CommissionPercentagePage",
            }] : []),
            ...(userRole === 1 ? [{
              id: "ContractorPhoneSettingsPage",
              label: "شماره همراه پیمانکار",
              link: "/ContractorPhoneSettingsPage",
            }] : []),

            // {
            //   id: "CommissionPercentagePage",
            //   label: "کارمزد پیمانکار",
            //   link: "/CommissionPercentagePage",
            // },
            {
              id: "Farmer-registration",
              label: "ثبت کشاورز ",
              link: "/FarmerPage",
            },
          ],
        },
        {
          id: "resivePaymankar",
          label: "عملیات پیمانکار",
          link: "/DashBoard",
          icon: <Edit3Icon />,
          subItems: [
            {
              id: "FactoryregistrationPayment",
              label: "ثبت واریزی کارخانه",
              link: "/FactoryregistrationPayment ",
            },
            {
              id: "SeedFactory",
              label: "ثبت بذر کارخانه",
              link: "/SeedFactory",
            },
            {
              id: "registerPoisonFactory",
              label: "ثبت سم کارخانه",
              link: "/registerPoisonFactory",
            },
            {
              id: "suger",
              label: "ثبت شکر کارخانه",
              link: "/sugerFactory",
            },
            {
              id: "sww",
              label: "ثبت تفاله کارخانه",
              link: "/FactoryWaste",
            },
          ],
        },
        {
          icon: <User size={20} />,
          id: "placed-farmer",
          label: "عملیات کشاورز",
          link: "/placed-farmer",
        },
        {
          icon: <Sprout size={20} />,
          id: "reposrtadasll",
          label: "صورتحساب کشاورزان",
          link: "/Report/invoice_Farmer",
        },
        {
          id: "feedAndChick",
          label: "گزارش گیری",
          link: "/#",
          icon: <BoxesIcon />,
          subItems: [
            ...(userRole !== undefined && userRole === 1
              ? [
                {
                  id: "reposrtaAllForALlreportsss",
                  label: "گزارش کلی",
                  link: "/Report/FullReport",
                },
                {
                  id: "reposrtasll",
                  label: "گزارش کارخانه ها",
                  link: "/Report/Factory",
                },
                {
                  id: "ChickensAndDan",
                  label: "گزارش بذر",
                  link: "/Report/RepostSeed",
                },
                {
                  id: "reposrt",
                  label: "گزارش سم",
                  link: "/Report/RepostPoison",
                },

                {
                  id: "reposrtallSuger",
                  label: "گزارش شکر",
                  link: "/Report/ReportSuger",
                },
                {
                  id: "reposrtallwaste",
                  label: "گزارش تفاله",
                  link: "/Report/ReportWaste",
                },
              ]
              : []),
          ],
        },
        {
          id: "sendsms-farmer",
          label: "مدیریت ارسال پیامک",
          link: "/#",
          icon: <MessageSquareMore />,
          subItems: [
            {
              id: "sendsms-farmer",
              label: "ارسال پیامک برای کشاورزان",
              link: "/SendSmsFarmer",
            },
          ],
        },
        {
          icon: <CheckCircle size={20} />,
          id: "ReadyLoad",
          label: "ثبت بار های  آماده حمل",
          link: "/ReadyLoad",
        },
        {
          id: "userManagement",
          label: "تنظیمات",
          link: "/#",
          icon: <SettingsIcon />,
          subItems: [
            {
              id: "manage-users",
              label: "مدیریت کاربران",
              link: "/manageUser",
            },
            {
              id: "change-password",
              label: "تغییر رمز عبور",
              link: "/user-profile",
            },
            {
              id: "logout",
              label: "خروج",
              link: "/logout",
            },
          ],
        },
        {
          id: "ContactUS",
          label: "پشتیبانی",
          link: "/#",
          icon: <BookCheck />,
          subItems: [
            {
              id: "ContactUS-ContactUS",
              label: "ارتباط با ما",
              link: "/ContactUS",
            },
          ],
        },
      ]
      : []),

    // برای کشاورز  منو 3
    ...(userRole === 3
      ? [
        {
          id: "Year-registration",
          label: "ثبت سال زراعی ",
          link: "/Year-registration",
        },
        {
          id: "DashBoardsuserDashboard",
          label: "داشبورد",
          link: "/userDashboard",
          icon: <DashboardIcon className="w-4 h-4" />,
        },
        {
          id: "yourcontract",
          label: "قرارداد شما",
          link: "/YourCommitment",
          icon: <ContractIcon className="w-4 h-4" />,
        },
        {
          id: "yourseeds",
          label: "بذرهای شما",
          link: "/YourSeeds",
          icon: <SeedsIcon className="w-4 h-4" />,
        },
        {
          id: "YourPesticides",
          label: "سم های شما",
          link: "/YourPesticides",
          icon: <PesticidesIcon className="w-4 h-4" />,
        },
        {
          id: "yourdeliveries",
          label: "بار های تحویلی شما",
          link: "/YourDeliveries",
          icon: <DeliveryIcon className="w-4 h-4" />,
        },
        {
          id: "yourpayments",
          label: "پرداختی ها به شما",
          link: "/Yourpayments",
          icon: <BadgeDollarSign className="w-4 h-4" />,
        },
        {
          id: "yoursugar",
          label: "سهمیه شکر شما",
          link: "/Yoursugar",
          icon: <LeafyGreen className="w-4 h-4" />,
        },
        {
          id: "yourpulp",
          label: "سهمیه تفاله شما",
          link: "/YourWast",
          icon: <PulpIcon className="w-4 h-4" />,
        },
        {
          id: "yourguarantees",
          label: "ضمانت های شما",
          link: "/Yourguarantees",
          icon: <GuaranteeIcon className="w-4 h-4" />,
        },
        {
          id: "initialData",
          label: "پشتیبانی",
          link: "/#",
          icon: <PhoneCall />,
          subItems: [
            {
              id: "ContactUS-ContactUS",
              label: "ارتباط با ما",
              link: "/ContactUS",
            },
            {
              id: "logout",
              label: "خروج",
              link: "/logout",
            },
          ],
        },
      ]
      : []),

    // برای رانندگان ادی 5
    ...(userRole === 5
      ? [
        // {
        //   icon: <CheckCircle size={20} />,
        //   id: "Year-registration",
        //   label: "ثبت سال زراعی ",
        //   link: "/Year-registration",
        // },
        {
          icon: <HardDriveIcon size={20} />,
          id: "registerdriver",
          label: "ثبت  راننده",
          link: "/registerdriver",
        },
        {
          icon: <CheckCircle size={20} />,
          id: "ReadyLoad",
          label: "ثبت بار های  آماده حمل",
          link: "/ReadyLoad",
        },
        {
          id: "initialData",
          label: "پشتیبانی",
          link: "/#",
          icon: <PhoneCall />,
          subItems: [
            {
              id: "ContactUS-ContactUS",
              label: "ارتباط با ما",
              link: "/ContactUS",
            },
            {
              id: "logout",
              label: "خروج",
              link: "/logout",
            },
          ],
        },
      ]
      : []),
  ];

  return menuData;
};

export default MenuData;
